import React, { Component } from 'react';
import { WelcomeContext } from '../../../base_components/rootComponents/Welcome';
import RecurveUtility from '../../../functions/utility';
import { MenuItemCard } from '../../../ui/menuItemCard';
import { MenuItemCardContainer } from '../../../ui/menuItemCardContainer';
import { ItemCustomizationDialog } from '../../../ui/itemCustomization';
import { MarketingDisplay } from '../../../ui/marketingDisplay';

export default class StreamlinedWelcome extends Component {
    constructor(props) {
        super(props);
        this.utility = { ...RecurveUtility };
        this.state = {
            isItemDialogOpen: false,
            itemDialogUrl: null,
            itemDialogTitle: 'Customize item'
        };
        this.openItemDialog = this.openItemDialog.bind(this);
        this.handleItemDialogOpenChange = this.handleItemDialogOpenChange.bind(this);
    }

    openItemDialog(itemUrl, itemName) {
        this.setState({
            isItemDialogOpen: true,
            itemDialogUrl: itemUrl,
            itemDialogTitle: itemName || 'Customize item'
        });
    }

    handleItemDialogOpenChange(open) {
        this.setState({
            isItemDialogOpen: open,
            itemDialogUrl: open ? this.state.itemDialogUrl : null
        });
    }

    render() {
        return (
            <div className={'mt-2'}>
                <WelcomeContext.Consumer>
                    {(welcomeContext) => {
                        return (
                            <div id="welcomePanel">
                                <MarketingDisplay placement="home" />
                                <div className="mb-1">
                                    {welcomeContext.categories.map((val) => {
                                        const menuItemCards = [];
                                        val.item_navigations.map((navigation) => {
                                            menuItemCards.push(
                                                <MenuItemCard
                                                    menu_id={navigation.menu_id}
                                                    description={navigation.description}
                                                    label={navigation.name}
                                                    levelPrice={navigation.level_price}
                                                    matrixWeight={navigation.matrix_weight}
                                                    itemGroup={navigation.item_group}
                                                    imageUrl={navigation.imageURL}
                                                    onCallToAction={() => {
                                                        this.openItemDialog(
                                                            `${window.relativeURI()}/menu/categories/${val.id}/items/${navigation.id}`,
                                                            navigation.name
                                                        );
                                                    }}
                                                    key={`${val.id}-${navigation.id}`}
                                                />
                                            );
                                        });
                                        const hasItemNavigations = val.item_navigations.length > 0;

                                        return (
                                            <section
                                                className={'m-1 text-left category-navigation-section'}
                                                key={`welcome-category-${val.id}`}
                                                data-category-id={hasItemNavigations ? `${val.id}` : undefined}
                                                aria-labelledby={hasItemNavigations ? `category-${val.id}` : undefined}
                                                aria-label={hasItemNavigations ? undefined : `${val.name}`}
                                            >
                                                <div
                                                    style={{
                                                        boxSizing: 'border-box',
                                                        fontWeight: '500',
                                                        height: '38px',
                                                        lineHeight: '38px',
                                                        fontSize: '16px',
                                                        color: 'rgb(37,37,37)'
                                                    }}
                                                >
                                                    {hasItemNavigations ? <h2 className={'theme-primary-text'} id={`category-${val.id}`}>{`${val.name}`}</h2> : null}
                                                </div>
                                                <MenuItemCardContainer children={menuItemCards} />
                                            </section>
                                        );
                                    })}
                                </div>
                            </div>
                        );
                    }}
                </WelcomeContext.Consumer>

                <ItemCustomizationDialog
                    open={this.state.isItemDialogOpen}
                    onOpenChange={this.handleItemDialogOpenChange}
                    itemUrl={this.state.itemDialogUrl}
                    title={this.state.itemDialogTitle}
                />
            </div>
        );
    }
}
